
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    telephone: String,
    email: String,
    website: String,
  },
})
export default class ContactLeft extends Vue {
  telephone!: string;
  email!: string;
  website!: string;
}
